var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookRenewal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53195 3.44169C9.49768 -0.899371 16.7765 -1.1769 21.052 2.85413L21.8191 1.0915C22.423 3.37634 22.9125 5.71008 23.2878 8.04399L17.6573 7.65223L18.6691 6.72206C15.4703 3.53968 10.0525 4.73114 7.32687 7.96248C7.81652 5.51443 9.69318 3.44181 9.69318 3.44181C9.69318 3.44181 7.76756 3.05027 5.53168 3.44181L5.53195 3.44169Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6383 10.035C27.1398 15.7141 23.4188 21.9811 17.7231 23.4007L18.784 25.0001C16.5319 24.2657 14.3122 23.4171 12.1417 22.4706L15.5198 17.9663L15.7484 19.3208C20.1548 18.3579 22.097 13.1681 20.8564 9.12109C22.6515 10.8509 23.3697 13.5601 23.3697 13.5601C23.3697 13.5601 24.757 12.1075 25.6382 10.0351L25.6383 10.035Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6729 23.2375C4.89556 22.1931 0.782901 16.1713 1.90945 10.4099L0 10.6874C1.61559 8.95757 3.32921 7.30925 5.10801 5.75879L7.76818 10.7364L6.4299 10.3774C5.43444 14.7838 9.31842 18.733 13.5127 19.3368C11.1789 20.2344 8.43721 19.7447 8.43721 19.7447C8.43721 19.7447 9.1552 21.5563 10.6731 23.2372L10.6729 23.2375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9353 15.4975C12.9263 15.6028 12.9921 15.6991 13.0939 15.7292C13.115 15.7353 13.1358 15.7382 13.1598 15.7382C13.2376 15.7382 13.3124 15.6961 13.3542 15.6239L15.1917 12.3809C15.2276 12.3177 15.2307 12.2425 15.2007 12.1764C15.1707 12.1102 15.1139 12.0621 15.042 12.047L13.9617 11.8184L14.1143 9.52005C14.1203 9.41477 14.0545 9.32144 13.9527 9.28836C13.854 9.26134 13.7462 9.30342 13.6953 9.39365L11.8549 12.6396C11.822 12.7028 11.816 12.778 11.846 12.8441C11.8759 12.9073 11.9357 12.9555 12.0046 12.9705L13.088 13.2022L12.9353 15.4975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookRenewal);
export default __webpack_public_path__ + "static/media/BookRenewal.e55400e7481b9f858832b74e93eb549b.svg";
export { ForwardRef as ReactComponent };